import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Flex } from 'antd';

import { BannerProps } from '../service/banners.interface';
import {
    useLazyReadBannersQuery,
    useUpdateBannerPositionMutation,
} from '../service/banners';
import { useFilters } from '../../products/hooks/useFilters';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import { BannersActions, BannersList } from '../components';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const BannersContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const {
        filters,
        get: fetchBanners,
        source,
        loading,
    } = useFilters<BannerProps, BannerProps>(useLazyReadBannersQuery, null);

    const [updateBannerPosition] = useUpdateBannerPositionMutation();

    useEffect(() => {
        const timeout = setTimeout(() => {
            const payload = {
                id: current.id,
                ...filters,
            };

            fetchBanners(payload, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, fetchBanners, current.id]);

    const updatePosition = async (items: BannerProps[]) => {
        await updateBannerPosition({
            shopId: current.id,
            list: items.map(item => item.id),
        });
    };

    return (
        <Flex vertical justify={'space-between'} gap={20}>
            <BannersActions />
            <BannersList
                loading={loading}
                updatePosition={updatePosition}
                banners={source.items || []}
            />
        </Flex>
    );
};
